import Vue from 'vue'

import Vuex from 'vuex'
Vue.use(Vuex)

import api from './api'
import peer from './peer'
import lists from './lists'
import project from './project'
import files from './files'
import activity from './activity'

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
    modules: {
        api, peer, lists, project, files, activity
    },
    
    strict: debug
})
